import React from 'react';
import { FormGroup } from 'components/common/Forms';
import { compose } from 'recompose';
import { trimStart } from 'lodash';
import { Control, Errors, actions } from 'react-redux-form';

const constructModel = (base, key) =>
  base ? `.${trimStart(base)}.${key}` : key;

const HelpText = ({ ...props }) => (
  <span className="form-text small text-danger" {...props} />
);

const changeThenValidate = dispatch => (model, value) => {
  dispatch(actions.change(model, value));
  dispatch(actions.validate(model));
};

export const UserDetails = ({
  mode,
  item,
  dispatch,
  renderServerError,
  readOnly,
  baseModel,
}) => (
  <div>
    {/* 
      Hidden password field to trick the credential autofill system, 
      means the users own password is autofilled here rather than in 
      the New User's password field 
    */}
    <input type="password" style={{ display: 'none' }} />
    <FormGroup label="Username *" model=".username">
      <Control.text
        updateOn="blur"
        model=".username"
        required
        disabled={!!item.id}
      />
    </FormGroup>
    {renderServerError(constructModel(baseModel, 'username'))}
    <FormGroup label="Installer Name *" model=".first_name">
      <Control.text
        updateOn="blur"
        model=".first_name"
        required
        disabled={readOnly}
      />
    </FormGroup>
    <FormGroup label="Email *" model=".email">
      <Control.text
        updateOn="blur"
        type="email"
        required
        model=".email"
        changeAction={changeThenValidate(dispatch)}
      />
      <Errors model=".email" component={HelpText} />
    </FormGroup>
    <FormGroup
      label={'Password' + (mode !== 'New' ? '' : ' *')}
      model=".password"
      hidden={readOnly}
    >
      <Control.text
        updateOn="blur"
        type="password"
        model=".password"
        validators={{ required: v => mode !== 'New' || v }}
        changeAction={(model, value) => {
          dispatch(actions.change(model, value));
          dispatch(actions.validate(model));
        }}
        autocomplete="new-password"
      />
      <Errors model=".password" component={HelpText} />
    </FormGroup>
    <FormGroup
      label={'Confirm Password' + (mode !== 'New' ? '' : ' *')}
      model=".confirmPassword"
      hidden={readOnly}
    >
      <Control.text
        updateOn="blur"
        type="password"
        model=".confirmPassword"
        validators={{ required: v => mode !== 'New' || v }}
        autocomplete="new-password"
      />
      <Errors
        model="."
        messages={{ passwordsMatch: 'Passwords do not match' }}
        component={HelpText}
      />
    </FormGroup>
    <FormGroup label="Active" check disabled={readOnly}>
      <Control.checkbox model=".is_active" />
    </FormGroup>
    {renderServerError(constructModel(baseModel, 'is_active'))}
    <FormGroup label="Reset Password on Next Login" check disabled={readOnly}>
      <Control.checkbox model=".reset_password" />
    </FormGroup>
    {renderServerError(constructModel(baseModel, 'reset_password'))}
  </div>
);

const enhance = compose();

export default enhance(UserDetails);



// WEBPACK FOOTER //
// ./src/pages/Installers/UserDetails.jsx